// import React from "react";
// import {
// 	Modal, ModalHeader, ModalBody,
// 	Button, Form
// } from "react-bootstrap";

// export default function Tested({
// 	isOpen, toggle, submit, changeHandler, reportText
// }) {

// 	return (
// 		<Modal isOpen={isOpen} className="text-translate-modal">
// 			<ModalHeader
// 				className="text-translation"
// 				tag="div"
// 			>
// 				Report the problem in this question.

// 				<Button className="modalCloseBtn" onClick={toggle}>
// 					<svg
// 						xmlns="http://www.w3.org/2000/svg"
// 						viewBox="0 0 24 24"
// 						width="24"
// 						height="24"
// 					>
// 						<path
// 							d="M18 6L6 18M6 6l12 12"
// 							stroke="currentColor"
// 							strokeWidth="2"
// 							strokeLinecap="round"
// 							strokeLinejoin="round"
// 						/>
// 					</svg>
// 				</Button>
// 			</ModalHeader>

// 			<ModalBody>
// 				<div className="custom-box">
// 					<div className="editor-wrapper">
// 						<div className="editor__input">
// 							{/* <Input
// 								type="textarea"
// 								value={reportText}
// 								name="reportText"
// 								onChange={changeHandler}
// 							/> */}
// 							<Form.Control type="textarea" value={reportText} name="reportText" onChange={changeHandler} />
// 						</div>
// 					</div>
// 				</div>

// 				<div className="text-center">
// 					<button
// 						type="button"
// 						className="outline-btn"
// 						onClick={submit}
// 						disabled
// 					>
// 						Submit Report
// 					</button>
// 				</div>
// 			</ModalBody>
// 		</Modal>
// 	);
// }

import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import ReportIcon from "assets/images/images_new/Report-icon.svg";

export default function Tested({
  isOpen,
  toggle,
  submit,
  changeHandler,
  reportText,
}) {
  const [validated, setValidated] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setValidated(false);
      setIsSubmitting(false);
    }
  }, [isOpen]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!reportText?.trim()) {
      setValidated(true);
      return;
    }

    if (isSubmitting) return;

    setValidated(false);
    setIsSubmitting(true);
    
    try {
      await submit();
    } finally {
      setIsSubmitting(false);
    }
  };

  const onChangeHandler = (e) => {
    setValidated(false);
    changeHandler(e);
  };

  return (
    <Modal
      show={isOpen}
      onHide={toggle}
      centered
      className="text-translate-modal"
    >
      <Modal.Header className="d-flex">
        <Modal.Title className="text-translation popup_heading m-0 gap-2">
          <div className="modal-header-img">
            <img src={ReportIcon} alt="multi-languages" />
          </div>          
          Report the problem in this question.
        </Modal.Title>

        <Button variant="link" className="modalClose-Btn p-0" onClick={toggle}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="24"
            height="24"
          >
            <path
              d="M18 6L6 18M6 6l12 12"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </Button>
      </Modal.Header>

      <Form noValidate validated={validated} onSubmit={handleSubmit}>
        <Modal.Body>
          <div className="custom-box p-0 m-0">
            <Form.Group controlId="reportText">
              <div className="editor-wrapper">
                <div className="editor__input">
                  <Form.Control
                    as="textarea"
                    rows={4}
                    name="reportText"
                    value={reportText}
                    onChange={onChangeHandler}
                    required
                    placeholder="Describe the issue..."
                  />
                </div>
              </div>

              {/* Validation text AFTER textarea */}
              <Form.Control.Feedback
                type="invalid"
                className={`${validated ? "report_validation" : "invalid-feedback"}`}
              >
                Report description is required.
              </Form.Control.Feedback>
            </Form.Group>
          </div>

          <div className="text-center mt-3">
            <Button
              type="submit"
              className="outline-btn"
              disabled={!reportText?.trim() || isSubmitting}
            >
              {isSubmitting ? 'Submitting...' : 'Submit Report'}
            </Button>
          </div>
        </Modal.Body>
      </Form>
    </Modal>
  );
}